import styled from "styled-components"

const Wrapper = styled.div`
  background: ${({theme}) => theme.colors.greys.white};
  border-radius: 3px 3px 0 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  display: flex;
  justify-content: space-between;
  padding: 10px;
`
export default Wrapper
